import { reducer as googleReviewsReducer } from './googleReviews.slice';

export default googleReviewsReducer;
